export default {
    apiAddress: `${process.env.REACT_APP_BACKEND_REALM}/`,
    headerTitle: 'DIABLO 4 INTERACTIVE MAP'
};
